import { ReactComponent as SiteLogoSvg } from '../../assets/images/site-logo.svg';

export const SiteLogoIcon: SvgIcon = (props) => {
    return <SiteLogoSvg {...props} />;
};
